import Swiper from 'swiper/dist/js/swiper.js'
import { TimelineMax } from 'gsap'
import { hasClass } from '../util/utils'
import fitvids from "fitvids"

/**
 * INIT
 * ----
 * This function initialize every element of the single post
 **/
export function init() {
  initSlider()
  initVideos()
  initFigureMaxWidth()

  window.addEventListener('resize', initFigureMaxWidth, true);
}

function initSlider() {
  let slider = []
  document.querySelectorAll('.gallery-swiper').forEach((el, index) => {
    slider[index] = new Swiper(el, {
      slidesPerView: 1,
      loop: false,
      loopedSlides: 2,
      spaceBetween: 0,
      grabCursor: false,
      navigation: {
        nextEl: el.querySelectorAll('.gallery-nav--next'),
        prevEl: el.querySelectorAll('.gallery-nav--prev')
      },
      pagination: false,
      mousewheel: false,
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
    })
  })
}

function initVideos() {
  fitvids('.featured-content-video')
}

function initFigureMaxWidth() {
  TweenLite.set([
    '.wp-caption', 
    '.wp-block-image'
  ], {clearProps: 'all'})

  setFigureMaxWidth('.wp-caption')
  setFigureMaxWidth('.wp-block-image')
}

function setFigureMaxWidth(classEl) {
  document.querySelectorAll(classEl).forEach((el, index) => {
    let figureMaxWidth = el.querySelectorAll('img')[0].width

    if(figureMaxWidth < window.innerWidth && !hasClass(el.parentNode, 'featured-content-image')) {
      TweenLite.set(el, { css: { maxWidth: figureMaxWidth+'px' } })
    } else {
      TweenLite.set(el, {clearProps: 'all'})
    }
  })  
}



// WEBPACK FOOTER //
// ./scripts/components/PostSingle.js